import { useMemo } from "react";
import useInvestorDetailStore from "../stores/investorDetailStore";
import useTenantDetailStore from "../stores/tenantDetailStore";
import { TicketAudience, TicketTaxonomy, ticketTaxonomy } from "../utils/tickets";

/** Investor wins where both stores are filled, as everywhere else in the portal. */
export const useTicketAudience = (): TicketAudience => {
  const hasInvestor = useInvestorDetailStore((state) => !!state.investor);
  const hasTenant = useTenantDetailStore((state) => !!state.tenant);
  return !hasInvestor && hasTenant ? "tenant" : "investor";
};

export const useTicketTaxonomy = (): TicketTaxonomy => {
  const audience = useTicketAudience();
  return useMemo(() => ticketTaxonomy(audience), [audience]);
};
